import { type Meta } from '../types/docs';
import { WORKSPACE_AGENT_ANALYTICS_CATEGORY_META_PARAM } from './workspaceAgentAnalytics';

export const WORKSPACE_AGENT_THREAD_LIST_OPENED_LOCATIONS = ['header', 'thread'] as const;

export type WorkspaceAgentThreadListOpenedLocation = (typeof WORKSPACE_AGENT_THREAD_LIST_OPENED_LOCATIONS)[number];

const META: Meta = {
  description: 'The user opens the My Tasks thread list in the workspace agent panel',
  name: 'agent_thread_list_opened',
  params: [
    WORKSPACE_AGENT_ANALYTICS_CATEGORY_META_PARAM,
    {
      description: 'Where the user opened the thread list from',
      name: 'location',
      required: true,
      type: 'enum',
      values: [...WORKSPACE_AGENT_THREAD_LIST_OPENED_LOCATIONS],
    },
  ],
};

export default META;
